import type { StatId } from '@/schemas/stats';

/**
 * Metadata di display delle 6 caratteristiche DWR.
 * - `abbr`: abbreviazione FOR/DES/COS/INT/SAG/CAR (manuale base).
 * - `name`: nome completo italiano.
 * - `debil`: nome della *debility* applicata quando la stat va sotto soglia
 *   (manuale base Dungeon World). Mostrata nel SectionStats (PR 5 Fase 2)
 *   sotto al nome della stat in italico ink-faint, e in futuro nei display
 *   stat di Hub/level-up quando la stat è soggetta a debility.
 *
 * Centralizzati qui per non duplicare nei componenti UI (SheetStat in Hub,
 * StatRow nel builder, MiniStat in aside, etc.).
 */
export const STAT_META: Record<StatId, { abbr: string; name: string; debil: string }> = {
  forza: { abbr: 'FOR', name: 'Forza', debil: 'Indebolito' },
  destrezza: { abbr: 'DES', name: 'Destrezza', debil: 'Squilibrato' },
  costituzione: { abbr: 'COS', name: 'Costituzione', debil: 'Malato' },
  intelligenza: { abbr: 'INT', name: 'Intelligenza', debil: 'Confuso' },
  saggezza: { abbr: 'SAG', name: 'Saggezza', debil: 'Stordito' },
  carisma: { abbr: 'CAR', name: 'Carisma', debil: 'Scosso' },
};

/**
 * Formatta un modificatore di caratteristica per display (es. `+2`, `-1`, `0`).
 * SSOT estratto da `SectionStats.tsx` durante PR 2 Fase 2 (pattern ricorrente:
 * 2+ punti UI che mostrano modifier).
 */
export function formatModifier(mod: number): string {
  return mod >= 0 ? `+${mod}` : String(mod);
}
